module.exports = __webpack_public_path__ + "img/default_head.562457a1.png";